import { render, staticRenderFns } from "./RevenueRecord.vue?vue&type=template&id=83b3923a&scoped=true"
import script from "./RevenueRecord.vue?vue&type=script&lang=js"
export * from "./RevenueRecord.vue?vue&type=script&lang=js"
import style0 from "./RevenueRecord.vue?vue&type=style&index=0&id=83b3923a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b3923a",
  null
  
)

export default component.exports